import { Box, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import PonduranceLogoFull from '@/assets/pondurance-horizontal-full-black.png';
import CoverWaveImage from '@/assets/report-cover-wave.png';
import InfoPageImage from '@/assets/report-info-silhouette.png';

import type { ReportsInfoPageProps } from './ReportsPage.types';

const ReportsPageInfo = (props: ReportsInfoPageProps) => {
  const { reportName, organizationName } = props;

  return (
    <Box
      data-testid="reports-page-info"
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
        padding: '20mm 0mm 30mm 105mm'
      }}
    >
      <Box
        component="img"
        src={CoverWaveImage}
        alt="Cover Wave"
        sx={{
          position: 'absolute',
          bottom: -120,
          left: -90,
          width: '120%',
          zIndex: 0,
          objectFit: 'contain'
        }}
      />
      {/* Background Silhouette Image */}
      <Box
        component="img"
        src={InfoPageImage}
        alt="Cover Figure"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: -20,
          height: '70%',
          zIndex: 0,
          objectFit: 'contain'
        }}
      />

      {/* Text Content - aligned right */}
      <Box sx={{ position: 'relative', zIndex: 2, maxWidth: '100%' }}>
        <Stack spacing={0.25}>
          <img
            src={PonduranceLogoFull}
            alt="Pondurance"
            style={{ width: '70%', left: -20 }}
          />

          {/* Box Line to separate content */}
          <Box
            sx={{
              backgroundColor: '#D1E2D5',
              height: '4px',
              width: '100%'
            }}
          />

          <Typography
            variant="h1"
            sx={{ fontWeight: 'bold', color: '#1C4A50', paddingTop: '20px' }}
          >
            Report Information
          </Typography>
          <Box
            sx={{
              backgroundColor: '#D1E2D5',
              height: '2px',
              width: '80%'
            }}
          />
          <Typography variant="body1" sx={{ color: '#1C4A50' }}>
            {organizationName}
          </Typography>
          <Typography variant="body1" sx={{ color: '#1C4A50' }}>
            Report Generated: {dayjs().format('MMMM DD, YYYY')}
          </Typography>
          <Typography variant="body1" sx={{ color: '#1C4A50' }}>
            {reportName}
          </Typography>
        </Stack>
        <Stack spacing={1} sx={{ marginTop: '20px' }}>
          <Typography
            variant="h1"
            sx={{ fontWeight: 'bold', color: '#1C4A50' }}
          >
            Pondurance Info
          </Typography>
          <Box
            sx={{
              backgroundColor: '#D1E2D5',
              height: '2px',
              width: '80%'
            }}
          />
          <Box>
            <Typography variant="h6" sx={{ color: '#026670' }}>
              Security Operations Center
            </Typography>
            <Typography variant="body1" sx={{ color: '#1C4A50' }}>
              soc@pondurance.com
            </Typography>
            <Typography variant="body1" sx={{ color: '#1C4A50' }}>
              +1 (833) 854-3214
            </Typography>
          </Box>
          <Box>
            <Typography variant="h6" sx={{ color: '#026670' }}>
              Incident Response Time
            </Typography>
            <Typography variant="body1" sx={{ color: '#1C4A50' }}>
              soc@pondurance.com
            </Typography>
            <Typography variant="body1" sx={{ color: '#1C4A50' }}>
              +1 (888) 385-1720
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default ReportsPageInfo;
